'use client';
import React, { FC, useEffect, useState } from 'react';
// TODO: Will revisit why TS is cranky here after rush to port Subflow code
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import { TooltipRefProps, Tooltip as ReactTooltip } from 'react-tooltip';
import ReactDOMServer from 'react-dom/server';
import { TOOLTIP_STYLING } from '@/core/constants';
import { RichText } from '@/components/common';
import { Document } from '@contentful/rich-text-types';
import { HelpCircle } from '../Icons';

interface ToolTipProps extends Partial<TooltipRefProps> {
  id: string;
  classes?: string;
  color?: string;
  height?: number;
  width?: number;
  strokeWidth?: number;
  content?: any;
  tooltipClassName?: string;
  containerClassName?: string;
  message?: string | JSX.Element;
  place?: 'top' | 'bottom';
  arrowColor?: string;
  offset?: number;
  opacity?: number;
  border?: string;
}

const ToolTip: FC<ToolTipProps> = ({
  id,
  classes,
  color,
  height,
  width,
  strokeWidth,
  content,
  place = 'bottom',
  tooltipClassName = '',
  containerClassName = '',
  message,
  arrowColor = '#FFFFFF',
  offset = 20,
  opacity = 1,
  border,
}) => {
  const [isMounted, setIsMounted] = useState<boolean>(false); // Need this for react-tooltip's SSR hydration issues

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <>
      {isMounted && (
        <>
          <div
            data-tip
            data-for={id}
            className={`${containerClassName} cursor-default focus-visible:rounded-full focus-visible:outline-offset-1`}
          >
            <HelpCircle
              id={id + '-tooltip-anchor'}
              data-testid={id}
              classes={classes}
              color={color}
              height={height}
              width={width}
              strokeWidth={strokeWidth}
            />
          </div>
          <ReactTooltip
            id={id}
            place={place}
            arrowColor={arrowColor}
            style={{
              backgroundColor: TOOLTIP_STYLING.BACKGROUND_COLOR,
              color: TOOLTIP_STYLING.TEXT_COLOR,
            }}
            className={`${tooltipClassName} h-fit rounded !px-8 !py-6 shadow-[0_5px_8px_#9f9f9f] text-left md:!text-base leading-7 z-10`}
            offset={offset}
            globalCloseEvents={{
              scroll: true,
            }}
            anchorSelect={`#${id}-tooltip-anchor`}
            // TODO: Will revisit why TS is cranky here after rush to port Subflow code
            /* eslint-disable @typescript-eslint/ban-ts-comment */
            // @ts-ignore
            html={ReactDOMServer.renderToStaticMarkup(
              <RichText content={content as Document} />,
            )}
            opacity={opacity}
            border={border}
            clickable
          >
            {message || null}
          </ReactTooltip>
        </>
      )}
    </>
  );
};

export default ToolTip;
